import { LEVEL_DEFAULT } from './HierarchyCard.data'
import { Container, Content } from './HierarchyCard.styles'
import { HierarchyCardProps } from './HierarchyCard.type'

const HierarchyCard = ({
  level = LEVEL_DEFAULT,
  children,
  spacingClass = 'regular',
  ...divProps
}: HierarchyCardProps) => (
  <Container {...divProps}>
    <Content level={level} spacingClass={spacingClass}>
      {children}
    </Content>
  </Container>
)

export default HierarchyCard
